module.exports = __webpack_public_path__ + "static/media/feature.7ecdfd4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/personalization/images/feature.png
// module id = 2922
// module chunks = 0